import { render, staticRenderFns } from "./AnnouncementItem.vue?vue&type=template&id=6e25e274&scoped=true&"
var script = {}
import style0 from "./AnnouncementItem.vue?vue&type=style&index=0&id=6e25e274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e25e274",
  null
  
)

export default component.exports